{
  "menuItems": [
    {
      "path": "/secure/funding/funding-pipeline",
      "title": "Funding",
      "icon": "pi pi-money-bill",
      "visible": true
    },
    {
      "path": "/secure/collateral",
      "title": "Collateral",
      "icon": "pi pi-send",
      "visible": true
    },
    {
      "path": "/secure/settlement",
      "title": "Settlement",
      "icon": "pi pi-dollar",
      "visible": true
    },
    {
      "path": "/secure/treasury",
      "title": "Treasury",
      "icon": "pi pi-building",
      "visible": true
    },
    {
      "path": "/secure/portfolio",
      "title": "Portfolio",
      "icon": "pi pi-briefcase",
      "visible": true
    },
    {
      "path": "/secure/financing",
      "title": "Financing",
      "icon": "pi pi-building-columns",
      "visible": true
    },
    {
      "path": "/secure/reporting",
      "title": "Reporting",
      "icon": "pi pi-chart-bar",
      "visible": true
    },

    {
      "path": "/secure/admin",
      "title": "Admin",
      "icon": "pi pi-cog",
      "visible": true
    }
  ]
}
